import { Component, inject, effect, ChangeDetectionStrategy } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";

import { selectUserContext, selectLoadingUser } from "src/app/store/user/user.selectors";
import { environment } from "src/environments/environment";

@Component({
    selector: "application-home-redirect",
    templateUrl: "./application-home-redirect.component.html",
    styleUrls: ["./application-home-redirect.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationHomeRedirectComponent {
    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly store = inject(Store);
    private readonly router = inject(Router);

    // =========================================================================
    // STORE SIGNALS
    // =========================================================================
    private readonly userSignal = toSignal(this.store.select(selectUserContext));
    private readonly loadingUserSignal = toSignal(this.store.select(selectLoadingUser), { initialValue: true });

    // =========================================================================
    // PUBLIC PROPERTIES
    // =========================================================================
    public readonly environment = environment;

    // =========================================================================
    // PRIVATE STATE
    // =========================================================================
    private redirected = false;

    // =========================================================================
    // EFFECTS
    // =========================================================================
    private readonly redirectEffect = effect(() => {
        const user = this.userSignal();
        const loading = this.loadingUserSignal();

        if (!user?.selectedCompany?.id || loading || this.redirected) return;

        // Only redirect to /<companyId>/quote when the user is genuinely on the
        // root URL. Deep links like /<companyId>/quote/<id> can mount this
        // component briefly during bootstrap (before the matcher route resolves);
        // navigating from here would clobber the deep URL.
        const url = this.router.url.split("?")[0].split("#")[0];
        if (url !== "/" && url !== "") return;

        this.redirected = true;
        this.router.navigate([`/${user.selectedCompany.id}/quote`]);
    });
}
